/*
 * @Date: 2023-07-26 14:16:27
 * @LastEditors: chuhongguang
 * @desc: 权限相关
 */
// 项目中很多地方通过用户名 '测试账户' 做了页面权限控制, 新增人员后很不方面, 这里统一映射
const nameMappings = new Map()
nameMappings.set('王木木', '测试账户')
nameMappings.set('测试账户', '测试账户')

const auth = {
  namespaced: true, // 开启命名空间

  state: {
    nameMappings
  }
}

export default auth



// WEBPACK FOOTER //
// ./src/store/auth.js